import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectors as licenseSelectors } from 'store/licenseManager'
import AdminK8PrepareMultiSiteView from './component'
import { addProgressToSites } from './helpers'

const AdminK8PrepareMultiSiteViewContainer = ({
  isFetching,
  sitesWithProgress,
}) => {
  return (
    <AdminK8PrepareMultiSiteView
      isFetching={isFetching}
      sites={sitesWithProgress}
    />
  )
}

AdminK8PrepareMultiSiteViewContainer.propTypes = {
  isFetching: PropTypes.bool,
  sitesWithProgress: PropTypes.array,
}

const mapStateToProps = state => {
  const adminK8Sites = licenseSelectors.selectActiveAdminK8Sites(state)
  const sitesWithProgress = addProgressToSites(adminK8Sites)
  const isFetching = state.licenseManger?.isFetchingUserSites || false
  return {
    sitesWithProgress,
    isFetching,
  }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminK8PrepareMultiSiteViewContainer)
